export const CONVERSATIONS_MIGRATION_SQL = `
CREATE TABLE conversation_summaries (
  id TEXT PRIMARY KEY NOT NULL,
  title TEXT NOT NULL,
  participant_ids_json TEXT NOT NULL,
  unread_count INTEGER NOT NULL DEFAULT 0 CHECK (unread_count >= 0),
  last_message_preview TEXT,
  last_message_at TEXT,
  updated_at TEXT NOT NULL
) STRICT;

CREATE TABLE conversation_messages (
  id TEXT PRIMARY KEY NOT NULL,
  conversation_id TEXT NOT NULL,
  sender_id TEXT NOT NULL,
  body TEXT NOT NULL,
  state TEXT NOT NULL CHECK (state IN ('pending', 'confirmed', 'failed')),
  client_message_id TEXT,
  server_message_id TEXT,
  failure_reason TEXT,
  created_at TEXT NOT NULL
) STRICT;

CREATE INDEX idx_conversation_messages_conversation_created
  ON conversation_messages(conversation_id, created_at, id);
CREATE INDEX idx_conversation_messages_client_id
  ON conversation_messages(client_message_id) WHERE client_message_id IS NOT NULL;

CREATE TABLE client_notifications (
  id TEXT PRIMARY KEY NOT NULL,
  notification_type TEXT NOT NULL,
  title TEXT NOT NULL,
  body TEXT NOT NULL,
  reference_id TEXT,
  read_at TEXT,
  created_at TEXT NOT NULL
) STRICT;

CREATE INDEX idx_client_notifications_created
  ON client_notifications(created_at, id);
CREATE INDEX idx_client_notifications_unread
  ON client_notifications(read_at, created_at, id);
`;
//# sourceMappingURL=006_conversations.sql.js.map